import { APPS } from "../../data/apps";
import { Reveal, SectionHeading } from "./Reveal";
import { AppStoreButton } from "./AppStoreButton";

export const AppsShowcase = () => (
  <section id="apps" className="section-pad relative overflow-hidden bg-tt-black" data-testid="apps-section">
    <div className="pointer-events-none absolute right-0 top-1/4 h-96 w-96 rounded-full bg-tt-gold/5 blur-[120px]" />
    <img
      src="/assets/horns_chrome_t.png"
      alt=""
      aria-hidden="true"
      className="pointer-events-none absolute -right-40 top-10 w-[640px] max-w-none opacity-[0.07]"
    />
    <img
      src="/assets/horns_wire_t.png"
      alt=""
      aria-hidden="true"
      className="pointer-events-none absolute -left-32 bottom-20 w-[520px] max-w-none opacity-[0.12]"
    />
    <div className="relative mx-auto max-w-7xl px-6">
      <SectionHeading
        eyebrow="The Suite"
        title="Apps For People Who Perform"
        subtitle="Every tool you need to run a flawless live show — from harmonic mixing to timecode, click tracks, charts, and the business side of the gig."
      />

      <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {APPS.map((app, i) => {
          const Icon = app.icon;
          return (
            <Reveal key={app.id} delay={(i % 3) * 0.08}>
              <div
                className="hover-lift group relative flex h-full flex-col overflow-hidden rounded-2xl metal-surface border border-white/5 p-7 hover:border-tt-gold/40"
                data-testid={`app-card-${app.id}`}
              >
                <div className="absolute inset-x-0 top-0 h-px glow-line opacity-0 transition-opacity group-hover:opacity-100" />

                <div className="mb-5 flex items-center gap-4">
                  <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-tt-gold/30 bg-gradient-to-br from-tt-gunmetal2 to-tt-black text-tt-gold transition-all duration-300 group-hover:border-tt-gold/60 group-hover:text-tt-goldsoft">
                    <Icon size={26} />
                  </div>
                  <div>
                    <h3 className="font-display text-xl font-semibold text-tt-chrome">{app.name}</h3>
                    <p className="font-grotesk text-xs text-tt-gold">{app.tagline}</p>
                  </div>
                </div>

                <p className="flex-1 text-sm leading-relaxed text-tt-silver/60">{app.description}</p>

                <div className="mt-5 flex flex-wrap gap-2">
                  {app.tags.map((t) => (
                    <span key={t} className="rounded-full border border-white/10 bg-white/5 px-3 py-1 font-grotesk text-[11px] text-tt-silver/70">
                      {t}
                    </span>
                  ))}
                </div>

                <div className="mt-6 border-t border-white/5 pt-5">
                  <AppStoreButton href={app.appStore} testid={`app-store-${app.id}`} />
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>

      <Reveal className="mt-14 text-center">
        <p className="text-sm text-tt-silver/45">
          App Store links are being finalized — check back soon, or follow Taurus Technology for launch updates.
        </p>
      </Reveal>
    </div>
  </section>
);
